(function () {
    // === Affichage dynamique des magasins disponibles dans le panier ===
    // Utilise StoreSelector.getStockedStores() défini dans theme.liquid

    function displayStoreAvailability() {
        const availabilityContainers = document.querySelectorAll('.product-availability-by-location[data-product-tags]');

        // Récupérer les magasins depuis StoreSelector (défini dans theme.liquid)
        if (typeof StoreSelector === 'undefined' || !StoreSelector.getStockedStores) {
            console.warn('⚠️ StoreSelector not available yet');
            return;
        }

        const stores = StoreSelector.getStockedStores();

        if (!stores || stores.length === 0) {
            console.warn('⚠️ Store locations not loaded yet');
            return;
        }

        availabilityContainers.forEach(container => {
            const productTags = container.getAttribute('data-product-tags').split(',').map(t => t.trim()).filter(Boolean);
            container.innerHTML = '';

            // Détecter le contexte (panier vs page produit) basé sur le tagName du conteneur
            const isCartContext = container.tagName.toLowerCase() === 'span';
            const iconSize = isCartContext ? 12 : 16;

            // Pour chaque magasin, vérifier si le produit a le tag correspondant
            stores.forEach(store => {
                if (productTags.includes(store.id)) {
                    const storeSpan = document.createElement('span');
                    storeSpan.className = 'availability-dot';
                    storeSpan.title = `Disponible à ${store.name}`;
                    const gap = isCartContext ? '3px' : '5px'; // Plus d'espace pour page produit
                    storeSpan.style.cssText = `display: inline-flex; align-items: center; gap: ${gap};`;

                    // Créer le SVG séparément pour éviter XSS avec store.name
                    const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="${iconSize}" height="${iconSize}" fill="#5c4738" viewBox="0 0 256 256">
                            <path d="M28.15,95A3.81,3.81,0,0,0,28,96v16a36,36,0,0,0,16,29.92V216a4,4,0,0,0,4,4H208a4,4,0,0,0,4-4V141.92A36,36,0,0,0,228,112V96a3.81,3.81,0,0,0-.17-1.08L213.5,44.7A12,12,0,0,0,202,36H54A12,12,0,0,0,42.5,44.7Zm22-48.08A4,4,0,0,1,54,44H202a4,4,0,0,1,3.84,2.9L218.7,92H37.3ZM100,100h56v12a28,28,0,0,1-56,0ZM36,112V100H92v12a28,28,0,0,1-41.37,24.59A4,4,0,0,0,49.32,135.83,28,28,0,0,1,36,112ZM204,212H52V145.94a36,36,0,0,0,44-17.48,36,36,0,0,0,64,0,36,36,0,0,0,44,17.48Zm2.68-76.17a3.94,3.94,0,0,0-1.3.76A28,28,0,0,1,164,112V100h56v12A28,28,0,0,1,206.68,135.83Z"></path>
                        </svg>`;

                    storeSpan.innerHTML = svgIcon;

                    // Ajouter le nom du magasin de manière sécurisée (textContent échappe automatiquement le HTML)
                    const storeNameText = document.createTextNode(store.name);
                    storeSpan.appendChild(storeNameText);

                    container.appendChild(storeSpan);
                }
            });
        });

    }

    // Attendre que les magasins soient chargés puis afficher
    function initStoreDisplay() {
        if (typeof StoreSelector !== 'undefined' && StoreSelector.getStockedStores && StoreSelector.getStockedStores().length > 0) {
            displayStoreAvailability();
        } else {
            setTimeout(initStoreDisplay, 200);
        }
    }

    // Initialiser au chargement de la page
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initStoreDisplay);
    } else {
        initStoreDisplay();
    }

    // Réafficher après mise à jour du panier
    document.addEventListener('theme:cart:change', function () {
        setTimeout(displayStoreAvailability, 100);
    });

    // === Fonction utilitaire pour attendre qu'un élément soit disponible dans le DOM ===
    function waitForElement(selector, maxAttempts = 50, interval = 100) {
        return new Promise((resolve, reject) => {
            let attempts = 0

            function checkElement() {
                const element = document.querySelector(selector)
                if (element) {
                    resolve(element)
                } else if (attempts < maxAttempts) {
                    attempts++
                    setTimeout(checkElement, interval)
                } else {
                    reject(new Error(`Élément ${selector} non trouvé après ${maxAttempts} tentatives`))
                }
            }

            checkElement()
        })
    }

    // Expose la fonction globalement pour réutilisation
    window.waitForElement = waitForElement

    // === Sécurité des liens externes ===
    var links = document.links;
    for (let i = 0; i < links.length; i++) {
        if (links[i].hostname !== window.location.hostname) {
            links[i].target = '_blank';
            links[i].rel = 'noreferrer noopener';
        }
    }

    // === Inversion symbole € ===
    const price = document.querySelector('.index-product .product__content .product__price span');
    if (price) {
        const varchar = price.textContent;
        if (varchar.length > 1 && varchar[0] === '€') {
            price.textContent = varchar.slice(1) + varchar[0];
        }
    }

    // === DÉTECTION ABSENCE DE #fulfillment-method-wrapper ===
    (function () {
        'use strict';

        // Ajoute un message d'erreur
        function addErrorMessage() {
            if (document.querySelector('.error-message-dingdoong')) return;

            const errorDiv = document.createElement('div');
            errorDiv.className = 'error-message-dingdoong';
            errorDiv.style.cssText = `
          background-color: #fee;
          border: 2px solid #e32636;
          border-radius: 6px;
          padding: 15px;
          margin: 10px 0;
          color: #c41e3a;
          font-weight: 600;
          font-size: 14px;
          display: flex;
          align-items: center;
          gap: 10px;
        `;

            const span = document.createElement('span');
            span.textContent = "⚠️ Il y a une incohérence sur la disponibilité magasin de vos produits.";

            errorDiv.appendChild(span);

            const checkoutBtn = document.querySelector('button[name="checkout"], input[name="checkout"]');
            if (checkoutBtn && checkoutBtn.parentNode) {
                checkoutBtn.parentNode.insertBefore(errorDiv, checkoutBtn);
            } else {
                document.body.insertBefore(errorDiv, document.body.firstChild);
            }

        }

        function removeErrorMessage() {
            const msg = document.querySelector('.error-message-dingdoong');
            if (msg) msg.remove();
        }

        function disableSubmitButtons() {
            const buttons = document.querySelectorAll('button[type="submit"][name="checkout"], input[type="submit"][name="checkout"]');
            buttons.forEach(btn => {
                btn.disabled = true;
                btn.style.opacity = '0.5';
                btn.style.cursor = 'not-allowed';
                btn.setAttribute('title', 'Formulaire temporairement désactivé');
                btn.setAttribute('data-disabled-dingdoong', 'true');
            });
        }

        function enableSubmitButtons() {
            const buttons = document.querySelectorAll('[data-disabled-dingdoong="true"]');
            buttons.forEach(btn => {
                btn.disabled = false;
                btn.style.opacity = '1';
                btn.style.cursor = 'pointer';
                btn.removeAttribute('title');
                btn.removeAttribute('data-disabled-dingdoong');
            });
        }

        const MAX_ATTEMPTS = 15;
        let checkAttempts = 0;
        let intervalId = null;

        function stopChecking() {
            if (intervalId !== null) {
                clearInterval(intervalId);
                intervalId = null;
            }
        }

        function checkFulfillmentWrapper() {
            waitForElement('#fulfillment-method-wrapper', MAX_ATTEMPTS, 100)
                .then(() => {
                    removeErrorMessage();
                    enableSubmitButtons();
                })
                .catch(() => {
                    addErrorMessage();
                    disableSubmitButtons();
                });
        }


        // Initialisation
        function init() {
            setTimeout(() => {
                checkFulfillmentWrapper();

                if (checkAttempts < MAX_ATTEMPTS && intervalId === null) {
                    intervalId = setInterval(() => {
                        checkFulfillmentWrapper();
                        if (intervalId !== null && (checkAttempts >= MAX_ATTEMPTS)) {
                            stopChecking();
                        }
                    }, 100);
                }
            }, 500);
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
        } else {
            init();
        }

        window.DingdoongChecker = {
            check: checkFulfillmentWrapper
        };


        document.addEventListener('theme:cart:change', function () {
            checkAttempts = 0
            stopChecking()
            init()
        })
    })()
})()